// Whether either side of a discrepancy carries the provenance a
// ReviewSourceChip would render (a quote or a positive confidence). Single
// source of truth for "will the chip show anything" so callers can skip
// rendering a bare label when it won't - kept in lockstep with the chip's own
// early return, which stays as the safety net.
export function hasReviewSource(d) {
    return !!d.sourceAfterQuote || d.sourceAfterConfidence > 0 || !!d.sourceBeforeQuote || d.sourceBeforeConfidence > 0;
}
// Picks which side of a discrepancy's before/after source citation to show in
// a ReviewSourceChip. The after side is this change item's own words for the
// proposed value, so it's preferred; fall back to the before side when the
// after side carries neither a quote nor a positive confidence. Shared by
// ModificationCenter and AwardComparisonPage - both carry the same
// source_before_*/source_after_* fields, but each names its two documents
// differently (modification vs. current contract; awarded contract vs. bid
// baseline), so callers supply the labels.
//
// The same side-selection also picks the artifact id and raw block span for
// that side, so "which side wins" stays decided here rather than duplicated
// in the chip or in ModificationCenter.
export function reviewSourceProps(d, labels) {
    const afterHasProvenance = !!d.sourceAfterQuote || d.sourceAfterConfidence > 0;
    if (afterHasProvenance) {
        return {
            quote: d.sourceAfterQuote || undefined,
            confidence: d.sourceAfterConfidence,
            page: d.sourceAfterPage,
            label: labels.after,
            artifactId: d.sourceAfterArtifactId || undefined,
            span: d.sourceAfterSpan || undefined
        };
    }
    return {
        quote: d.sourceBeforeQuote || undefined,
        confidence: d.sourceBeforeConfidence,
        page: d.sourceBeforePage,
        label: labels.before,
        artifactId: d.sourceBeforeArtifactId || undefined,
        span: d.sourceBeforeSpan || undefined
    };
}
